<template>
  <div>

    <div style="display: flex; align-items: center">
      <div
        style="display: flex; align-items: center; margin: 10px 10px 10px 10px"
        v-if="$store.languages.length"
      >
        <span style="margin-right: 10px">Secondary Language:</span>
        <select v-model="$store.secondaryLanguageMT">
          <option v-if="$store.languages.length > 0" value disabled selected>
            Select Language
          </option>
          <option v-if="$store.languages.length == 0">
            No languages were found
          </option>
          <option
            v-for="(language, index) in $store.languages"
            :key="index"
            v-bind:value="language.id"
          >
            {{ language.name }}
          </option>
        </select>
      </div>
      <label style="margin-left: 20px">
        <input
          type="checkbox"
          class="filled-in"
          v-model="$store.inspectionViewMT"
        />
        <span>Inspection view</span>
      </label>
    </div>
    <div v-if="!instanceSelected">
      <div
        v-if="loading"
        style="
          width: 100%;
          height: 70vh;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <Spinner />
      </div>
      <div v-if="!loading">
        <InstanceSelector v-on:loadInstance="loadInstance" />
      </div>
    </div>
    <div v-else class="row">
      <div class="col s12">
        <div class="card">
          <div
            style="
              position: fixed;
              top: 5px;
              right: 20px;
              display: flex;
              flex-direction: row;
              align-items: center;
              z-index: 999;
              padding: 5px;
              border-radius: 2px;
              box-shadow: 1px 1px 3px #888;
              background: white;
            "
            v-if="!loading"
          >
            <span
              title="Move to top"
              class="material-icons move-btn"
              style="padding: 5px 10px; border-left: 1px solid #ebebeb;border-right: 1px solid #ebebeb"
              @click="moveToTop()"
              >vertical_align_top</span
            >
          </div>
          <ul v-show="!loading && !emptyInstance" class="browser-default dialog-tree-row">
            <ReviewTreeItem
              v-for="(dialog, index) in nextDialogs"
              :key="index"
              :dialog="dialog"
              :parentOpen="true"
              :itemNumber="''"
            />
          </ul>
          <div v-if="!loading && emptyInstance" style="display:flex;align-items:center;justify-content:center;height:50vh;font-size:18px;font-weight:500">
            {{instance}} is empty!
          </div>
          <div
            style="
              width: 100%;
              height: 70vh;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
            v-if="loading"
          >
            <Spinner />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewTreeItem from "../components/ReviewTreeItem";
import InstanceSelector from "../components/InstanceSelector";
import Spinner from "../components/Spinner";
export default {
  name: "reviewtree",
  components: {
    ReviewTreeItem,
    InstanceSelector,
    Spinner,
  },
  data() {
    return {
      message:"",
      chunkLoaded:0,
      totalChunks:0,
      instances: [],
      instanceSelected: false,
      rootDialogID: "",
      instance: "",
      nextDialogs: {},
      loading: true,
      displaySecondaryLanguage: false,
      secondaryLanguage: "",
      phraseID: [],
      dataPackageAvailable: false,
      dataPackageVersion: -1,
      dataPackageDate: null,
      emptyInstance:false,
    };
  },
  updated() {
    M.FormSelect.init(document.querySelectorAll("select"), {});
  },
  mounted() {
    M.FormSelect.init(document.querySelectorAll("select"), {});
    this.$store.dialogsMT = {};
    this.$store.phrasesMT = {};
    this.$store.instances = [];
    this.$store.loadCount = 0;
    this.$store.secondaryLanguageMT = "";
    this.$store.inspectionViewMT = false;
    this.$store.lastPhraseUpdated = {};
    this.message = "";
    this.chunkLoaded = 0;
    this.totalChunks = 0;
    this.emptyInstance = false;
    this.$store.checkVisibility = false;
    this.$store.getAllDynamicVideoLanguageItems();
    this.$http.get("dialogs?tag=start").then((r) => {
      r.data.forEach((i) => {
        var instance = {};
        instance.id = i.id;
        i.tags.forEach((tag) => {
          if (tag.includes("start_")) {
            var name = tag.split("start_")[1];
            instance.name = name;
          }
        });
        this.$store.instances.push(instance);
      });
      this.loading = false;
    });
  },
  watch: {
    "message":function(val){
      M.Toast.dismissAll();
      M.toast({"html":val,"classes":"blue","displayLength":99999999,"outDuration":0,"inDuration":0});
    },
    "$store.loadCount": function (val) {
      if (val == 0) {
        this.$store.phrasesMT = {};
        this.loading = false;
        M.Toast.dismissAll();
        this.$store.checkVisibility = true;
        this.moveToTop();
      }
    },
    "$store.preferredLanguage": function () {
      if(this.$store.reviewTreePlayer){
        this.$store.reviewTreePlayer.pause();
        this.$store.reviewTreePlayer = null;
      }
      if(this.$store.reviewTreeItem){
        this.$store.reviewTreeItem.playing = false;
      }
      this.moveToTop();
    }
  },
  beforeRouteLeave(to, from, next) {
    if(this.$store.reviewTreePlayer){
      this.$store.reviewTreePlayer.pause();
      this.$store.reviewTreePlayer = null;
    }
    if(this.$store.reviewTreeItem){
      this.$store.reviewTreeItem.playing = false;
    }
    this.$store.reviewTreeItem = null;
    next();
  },
  methods: {
    moveToTop() {
      window.scrollTo(0, 0);
    },
    loadInstance(instance) {
      this.message = "Loading Data Package";
      this.$store.loadCount = 0;
      this.loading = true;
      instance = instance.split("@@");
      const dataVersion = instance[2];
      this.instance = instance[0];
      this.$store.instanceMT = this.instance;
      this.$http
        .get(
          "settings/datapackage?instance=start_" +
            instance[0] +
            "&version=" +
            dataVersion
        )
        .then(async (r) => {
          if(!r.data.phrases || (r.data.phrases && r.data.phrases.length == 0)){
            this.emptyInstance = true;
            this.instanceSelected = true;
            this.loading = false;
            M.Toast.dismissAll();
            return;
          }
          var phraseIDS = [];
          r.data.dialogs.forEach(dg => {
            if(phraseIDS.indexOf(dg.phrase) < 0) phraseIDS.push(dg.phrase);
            if(dg.tags && dg.tags.indexOf("start") >= 0){
              phraseIDS.pop();
            }
            if(dg.tags && dg.tags.indexOf("paragraph") >= 0){
              dg.tags.forEach(tag => {
                if(tag.includes("phrase_")){
                  var phraseID = tag.split("_")[1];
                  if(phraseID && phraseIDS.indexOf(phraseID) < 0) phraseIDS.push(phraseID);
                }
              })
            }
          })
          this.message = "Loading Phrases 0%";
          var p = [];
          while(phraseIDS.length != 0){
            var chunk = phraseIDS.splice(0, 200);
            if(chunk.length == 1) chunk.push(chunk[0]);
            chunk = chunk.join();
            p.push(this.getPhraseChunk(chunk));
            this.totalChunks++;
          }
          await Promise.all(p);
          r.data.dialogs.forEach((d) => {
            if(d.order){
              d.order = [...new Set(d.order)]
            }
            if(d.tags && d.tags.indexOf("paragraph") >= 0){
              var nextParagraph = [];
              d.tags.forEach(tag => {
                if(tag.includes("phrase_")){
                  var p = tag.split("_");
                  if(this.$store.phrasesMT[p[1]]){
                    var di = {
                      old_id:d.id,
                      id: d.id + p[3],
                      phrase: p[1],
                      order: [],
                      type: "instruction_paragraph",
                      tags: [],
                    }
                    this.$set(this.$store.dialogsMT, di.id, di);
                    nextParagraph.push(di.id);
                  }
                }
              })
              d.order = d.order ? d.order : [];
              nextParagraph.forEach(p => d.order.push(p));
            }
            var dialog = {
              old_id: d.id,
              id: d.id,
              phrase: d.phrase,
              order: d.order,
              type: d.type,
              tags: d.tags,
            };
            if(this.$store.phrasesMT[dialog.phrase] || (dialog.tags && dialog.tags.indexOf("start") >= 0)) this.$set(this.$store.dialogsMT, d.id, dialog);
          });
          for (var dID in this.$store.dialogsMT) {
            var dialog = this.$store.dialogsMT[dID];
            var indices = [];
            if (dialog.order)
              dialog.order.forEach((id, i) => {
                if (!this.$store.dialogsMT[id]) {
                  indices.push(i);
                }
              });
            indices = indices.reverse();
            if (indices.length > 0) {
              indices.forEach((i) => {
                dialog.order.splice(i, 1);
              });
            }
            this.$store.dialogsMT[dID] = dialog;
          }
          this.rootDialogID = instance[1];
          this.instanceSelected = true;
          var rootDialog = this.$store.dialogsMT[instance[1]];
          var dialog = {};
          dialog.tags = ["start"];
          dialog.phrase = "";
          dialog.id = this.rootDialogID;
          dialog.old_id = this.rootDialogID;
          dialog.next = rootDialog.order;
          dialog.type = "";
          this.$store.loadCount += dialog.next.length;
          this.$set(this.nextDialogs, dialog.id, dialog);
        });
    },
    getPhraseChunk(chunk){
      return new Promise((resolve, reject) => {
        this.$http.get("/phrases/" + chunk).then(res => {
          res.data.forEach(p => {
            // if(p.translations) {
            //   p.translations = p.translations.filter(t => t.language == this.pLang);
            // }
            // else{
            //   p.translations = [];
            // }
            // if(p.attachments) {
            //   p.attachments = p.attachments.filter(a => a.language == this.pLang);
            // }
            // else{
            //   p.attachments = [];
            // }
              this.$set(this.$store.phrasesMT, p.id, p);
           })
           this.chunkLoaded++;
           var percentLoaded = (this.chunkLoaded/this.totalChunks) * 100;
           percentLoaded = percentLoaded.toFixed(0);
           if(parseInt(percentLoaded) > 95){
             this.message = "Rendering Data";
           }else{
             this.message = "Loading Phrases " + percentLoaded + "%";
           }
           resolve();
        })
      });
    },
  }
};
</script>

<style scoped>
.card {
  padding: 1em;
}
.dialog-tree-row {
  list-style-type: none;
  padding-left: 1em;
}
.move-btn:hover {
  cursor: pointer;
}
</style>
